import Page from './component';

export default Page;
